import React, { useContext, useState } from 'react'
import View from '@modul-connect/shared/components/atoms/view'
import { PaperTitle } from '@modul-connect/shared/components/atoms/text/text'
import TimeSelectionRow from './timepickerRow'
import { borderStyle } from './paperWithHeader'
import { ReportContext } from '../../../../portal/src/pages/reports/reportPage.v2'
import { SearchField } from '../../molecules/searchWidget.v2/searchField'
import theme from '../../../theme'
import { ReportDownloadAllButton } from '../../../../portal/src/pages/reports/reportDownloadButton'
import { BubbleLoadingWidget } from '../../molecules/bubbleLoadingWidget/bubbleLoadingWIdget'
import Button from '../../atoms/button/button.v2'
import { Menu, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'

const styles = {
  headerWrapper: ({ theme: { layout, colors } }) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.barBackground,
    borderTopRightRadius: `${1 * layout.grid}px`,
    borderTopLeftRadius: `${1 * layout.grid}px`,
    '> div': {
      display: 'flex',
      flexDirection: 'row',
      color: colors.primary,
      '> p': {
        color: colors.primary,
      },
    },
  }),
  headerItem: () => ({
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 7.5,
    paddingBottom: 7.5,
  }),
  actionRow: () => ({
    height: '62px',
    minHeight: '62px'
  }),
  header_button: () => ({
    fontSize: '12px',
  }),
  rowItem: () =>({
    display: 'flex',
    alignItems: 'center',
    paddingRight: '5px',
    paddingLeft: '5px',
    height: '100%',
    justifyContent: 'center'
  }),
  divider: () =>({
    height: '60%', 
    borderRight: borderStyle,
    display: 'flex',
    alignItems: 'center'
  })
}


export const Header = ({
  title,
  groupingOptionSelector,
  onTimeframePicked,
  onStartDatePicked,
  onEndDatePicked,
  noFilterBar,
  noTimePickerBar,
  noSearch,
  onSearchChange,
  onDownload,
  onDownloadAll,
  filterDropdowns,
  searchValue,
  timeSelectors,
  button,
  sideFitleringComponent,
  isLoading,
  isPreparingFile,
  hasData,
  actionItems,
  editing,
  setEditing
}) => {
  return (
    <View extend={styles.headerWrapper}>
      <View extend={[styles.headerItem, { borderBottom: borderStyle }]}>
        {title && <PaperTitle text={title} />}
      </View>
      {button ? <View style={{ background: theme.colors.white, padding: '22px, 0px, 22px, 0px', height: 50 }}>
        {button}
      </View> : null}

      {noTimePickerBar ? null : <View
        extend={[
          styles.headerItem,
          {
            paddingBottom: 0,
            paddingTop: 0,
            borderBottom: borderStyle,
          },
        ]}
      >
        <TimeSelectionRow
          onTimeframePicked={onTimeframePicked}
          onStartDatePicked={onStartDatePicked}
          onEndDatePicked={onEndDatePicked}
          onDownload={onDownload}
          timeSelectors={timeSelectors}
        />
        
      </View>}

      {noFilterBar 
        ? null 
        : (
          <View extend={styles.headerItem}>
            {
              <FilterRow
                groupingOptionSelector={groupingOptionSelector}
                noSearch={noSearch}
                onSearchChange={onSearchChange}
                filterDropdowns={filterDropdowns}
                searchValue={searchValue}
                sideFitleringComponent={sideFitleringComponent}
              />
            }
            {!onDownloadAll ? null : (
              isPreparingFile ? (
                <BubbleLoadingWidget horizontal text='Preparing file...' extend={{ height: '35px', width: '200px' }}/>
              ) : (
                <ReportDownloadAllButton
                  disabled={!hasData}
                  onClick={onDownloadAll}
                />
              )
            )}
          </View>
        )}
      { 
        actionItems 
          ? <ActionRow actionItems={actionItems} editing={editing} setEditing={setEditing}/>
          : null
      }
    </View>
  )
}

// TODO: implement filtering via the dropdowns
// TODO: implement searching
const rowItemStyle = {
  flex: 1,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
}
const FilterRow = ({ 
  groupingOptionSelector, 
  noSearch, 
  onSearchChange, 
  filterDropdowns, 
  searchValue,
  sideFitleringComponent
}) => {

  const isLoading = useContext(ReportContext).isLoading

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
      }}
    >
      <View style={{ flex: 1, display: 'flex', alignContent: 'flex-start' }}>
        {
          groupingOptionSelector 
            ? groupingOptionSelector 
            : null}
      </View>

      <View style={{ flex: 1, display: 'flex', flexDirection: 'row', gap: 32 }}>
        {
          filterDropdowns?.length 
            ? filterDropdowns.map((filter, index) => {
              return <View key={index} style={rowItemStyle}>{filter}</View>
            }) 
            : !sideFitleringComponent
              ? <View style={rowItemStyle} />
              : null
        }
        { 
          sideFitleringComponent 
            ? sideFitleringComponent
            : null
        }
        <View style={{ ...rowItemStyle }}>
          {noSearch 
            ? null 
            : <SearchField 
              disabled={isLoading} 
              v2 
              flexWidth 
              boxShadow 
              placeholder="Search" 
              defaultValue={searchValue} 
              onChange={onSearchChange && ((event) => onSearchChange(event.target.value))} 
            />
          }
        </View>
      </View>
    </View>
  )
}

const ActionButton = ({ disabled, actionItems }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const {t} = useTranslation()

  return (
    <View extend={{
      display: 'flex',
      flexDirection: 'row'
    }}>
      <Button
        noBg
        small
        icon={disabled ? 'DropdownDisabled' : 'Dropdown'}
        extend={styles.header_button({ theme })}
        onClick={handleClick}
        disabled={disabled}
      >
          {t('actions')}
      </Button>
      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {
          actionItems.map((actionItem) => {
            return (
              <MenuItem key={actionItem.title} onClick={() => {
                handleClose()
                actionItem.action()
              }}>{actionItem.title}</MenuItem>
            )
          })
        }
      </Menu>
    </View>

  )
}


const ActionRow = ({ actionItems, editing, setEditing }) => {
  const {t} = useTranslation()
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
        alignItems: 'center'
      }}
    >
      <View style={{ ...styles.divider({ theme }) }}>
        <View style={{ ...styles.rowItem({ theme }) }}>
          <Button dark noBg icon={editing ? 'Close' : 'Pencil'} extend={styles.header_button({ theme })} onClick={() => setEditing(prev => !prev)} >{t('edit')}</Button>
        </View>
      </View>
      <View style={{ ...styles.rowItem({ theme }) }}>
        <ActionButton disabled={!editing} actionItems={actionItems}/>
      </View>
    </View>
  )
}
